import Initialiser from 'initialiser';
import { cloneDeep } from 'utils/immutable';
import constants from 'utils/constants';
import { logout } from 'ducks/modules/user';
import api from 'utils/api';
import { isImpelMember } from 'utils/auth';

// ACTION TYPES
const START_FETCH_WORKS = 'START_FETCH_WORKS';
const UPDATED_WORKS = 'UPDATED_WORKS';

// SYNC ACTION CREATORS
export function startFetchWorks() {
    return { type: START_FETCH_WORKS };
}
export function updatedWorks(works) {
    return { type: UPDATED_WORKS, works };
}

// ASYNC ACTION CREATORS
export function fetchWorks(offset, limit, data) {
    return async (dispatch) => {
        dispatch(startFetchWorks());
        try {
            const response = await api.searchWorks(offset, limit, data);
            const works = response.data;

            dispatch(
                updatedWorks({
                    total: response.total,
                    offset,
                    limit,
                    works: works.map((r) => {
                        const source = r._source;
                        return {
                            conflicts: !!source.conflicts,
                            conflicting_territories: source.country_list,
                            iswc: source.iswc,
                            title: source.title,
                            catalogue_type: source.catalogue_type,
                            sid: source.sid,
                            bk_work_id: source.bk_work_id,
                            dirty: source.dirty,
                            artists: source.artist_names,
                            writers: source.writers,
                            claims_claimant: isImpelMember() ? 0 : source.claims_claimant,
                            claims_defendant: isImpelMember() ? 0 : source.claims_defendant,
                            popularity: source.popularity,
                        };
                    }),
                }),
            );
        } catch (err) {
            console.error('Error fetching works: ', err);
            dispatch(updatedWorks({ total: 0, offset: 0, limit: 0, works: [] }));
            if (err && err.status === constants.HttpCodes.UNAUTHORIZED) {
                return dispatch(logout(err.data === constants.ServerCodes.TOKEN_EXPIRED));
            } else if (err && err.status === constants.HttpCodes.FORBIDDEN) {
                return Initialiser.history.replace('/forbidden');
            } else if (err && err.status === constants.HttpCodes.BAD_REQUEST) {
                return Initialiser.history.replace('/notfound');
            }
        }
    };
}

// REDUCER
export default function reducer(state = Initialiser.initialState.works, action) {
    switch (action.type) {
        case UPDATED_WORKS:
            return cloneDeep(action.works);
        default:
            return state;
    }
}
